import { Injectable } from '@angular/core'
import {
	Resolve,
	ActivatedRouteSnapshot,
	RouterStateSnapshot
} from '@angular/router'
import { Observable } from 'rxjs'
import { Evaluation } from '../../../models/Evaluation'
import { EvaluationService } from '../../../services/evaluation.service'

@Injectable({ providedIn: 'root' })
export class EvaluationResolver
	implements Resolve<Observable<Array<Evaluation>>> {
	constructor(private evaluationService: EvaluationService) {}

	public resolve(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<any> {
		const companyId = localStorage.getItem('companyId')
		return this.evaluationService.getEvaluations(companyId)
	}
}
